import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "material-symbols";
import reportWebVitals from "./reportWebVitals";


import App from "./App";
import { store } from "./app/store";

// 開発環境でのコンソール警告フィルタリング
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  const originalWarn = console.warn;
  
  console.error = (...args: any[]) => {
    const message = args[0]?.toString() || '';
    
    // React 19のref警告をフィルタリング
    if (message.includes('Accessing element.ref was removed in React 19')) {
      return;
    }
        
    originalError.apply(console, args);
  };
  
  console.warn = (...args: any[]) => {
    const message = args[0]?.toString() || '';
    
    // React 19関連の警告をフィルタリング
    if (message.includes('element.ref') || message.includes('React 19')) {
      return;
    }
    
    originalWarn.apply(console, args);
  };
}

// 旧 URL 互換: かつて SPA 本体は `/spa` 配下（basename="/spa"）で配信していた。
// 現在はルート直下（soremo.jp/）で配信する。旧ブックマーク等の `/spa/...` は
// CloudFront が 301 で剥がすが、エッジ未伝播やキャッシュ済み HTML への保険として
// クライアント側でも `/spa` プレフィックスを剥がしてから起動する。
const { pathname, search, hash } = window.location;
if (pathname === "/spa" || pathname.startsWith("/spa/")) {
  const stripped = pathname.slice("/spa".length) || "/";
  window.history.replaceState(null, "", stripped + search + hash);
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);

reportWebVitals(console.log);
